import styles from "./ChecklistsPage.module.css"
import HeaderPage from "../../components/HeaderPage";
import MiniCardUser from "../../components/MiniCardUser";
import SearchBar from "../../components/SearchBar";
import Checklist from "../../components/Checklist";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import { getChecklists } from "../../api/checklists.api";
import { toast } from "react-toastify";
import { FileCheck, CircleCheckBig, CircleX } from 'lucide-react';
import 'react-toastify/dist/ReactToastify.css';
import ChecklistModal from "../../components/ChecklistModal";
import { check } from "../../api/users.api";
import Pagination from "../../components/Pagination";

function ChecklistsPage({ setCanAccess }) {

    const month = String(new Date().getMonth() + 1).padStart(2, "0")

    const navigate = useNavigate();
    const [checklists, setChecklists] = useState([]);
    const [search, setSearch] = useState("");
    const [checklist, setChecklist] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);



    const openModal = (selectedChecklist) => {
        setChecklist(selectedChecklist);
        setIsOpen(true);
    }

    function parseDateTime(data, hora) {
        const [dia, mes, ano] = data.split("/");
        return new Date(`${ano}-${mes}-${dia}T${hora}`);
    }

    function executarAlerta(mensagem) {
        return toast.success(mensagem);
    }

    useEffect(() => {
        check()
            .then(() => {
                getChecklists(currentPage)
                    .then((res) => {
                        setTotalRecords(res.data.totalRecords);
                        setTotalPages(res.data.totalPages);

                        setChecklists(res.data.data.sort((a, b) => {
                            const dateA = parseDateTime(a.data, a.hora);
                            const dateB = parseDateTime(b.data, b.hora);
                            return dateB - dateA;
                        }))
                    })
                    .catch((error) => {
                        setChecklists([])
                        if (error.response.status == 401) {
                            return toast.error("Não autorizado!");
                        } else if (error.response.status != 200) {
                            return toast.error("Erro! Verificar com suporte");
                        }
                    })
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    navigate("/login")
                } else if (error.response.status != 200) {
                    return toast.error("Nenhum Checklist Criado");
                }
            })

    }, [])

    useEffect(() => {
        getChecklists(currentPage)
            .then((res) => {
                setChecklists(res.data.data.sort((a, b) => {
                    const dateA = parseDateTime(a.data, a.hora);
                    const dateB = parseDateTime(b.data, b.hora);
                    return dateB - dateA;
                }))
            })
            .catch((error) => {
                setChecklists([])
                if (error.response.status == 401) {
                    return toast.error("Não autorizado!");
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            })
    }, [currentPage]) 



    const filteredChecklists = Array.isArray(checklists) ? checklists.filter(check =>
        check.data?.toLowerCase().includes(search.toLowerCase()) ||
        check.hora?.toLowerCase().includes(search.toLowerCase()) ||
        check.car.placa?.toLowerCase().includes(search.toLowerCase()) ||
        check.tecnico?.name?.toLowerCase().includes(search.toLowerCase())
    ) : []

    return (
        <main className={styles.container}>
            <section className={styles.containerOne}>
                <HeaderPage
                    title="Checklists"
                    textTitle="Gerencie sua frota de veículos"
                    textBtn="Checklist"
                    setIsOpen={() => {
                        setCanAccess(true)
                        setTimeout(() => navigate("/checklist/new"), 0);
                    }}
                />
                <div className={styles.miniCard}>
                    <MiniCardUser
                        icon={<FileCheck size={16} color="#f97015" />}
                        text="Total"
                        data={totalRecords}
                    />
                    <MiniCardUser
                        text="Sem Avarias"
                        icon={<CircleCheckBig size={16} color="hsl(142 71% 45%)" />}
                        data={checklists.filter(check => check.aprovado === true).length}
                    />
                    <MiniCardUser
                        icon={<CircleX size={16} color="#ff2c2c" />}
                        text="Com Avarias"
                        data={checklists.filter(check => check.aprovado === false).length}
                    />
                    <MiniCardUser
                        icon={<FileCheck size={16} color="#f97015" />}
                        text="Total Mês"
                        data={checklists.filter(check => check.data.split("/")[1] == month).length}
                    />
                </div>
                <p
                    style={{
                        backgroundColor: "#ff2c2c",
                        color: "#fff",
                        width: "100%",
                        padding: "0.5rem",
                        borderRadius: "6px",
                    }}
                >⚠️ Estamos realizando ajustes na funcionalidade de paginação e filtro. Durante este período, os indicadores dos cards podem não refletir os valores reais dos checklists.</p>
                <div className={styles.searchBarAndPagination}>
                    <SearchBar setSearch={setSearch} />
                    <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                </div>
            </section>
            <section className={styles.cards}>
                {filteredChecklists.map((check, index) => <Checklist thisChecklist={check} openModal={openModal} key={index + 1} />)}
            </section>

            {isOpen && (
                <ChecklistModal thisChecklist={checklist} setIsOpen={setIsOpen} />
            )}
        </main >
    )
}

export default ChecklistsPage;